<template>
  <div>
    <ReAssignPOSModal :modalData="modalData" />
    <MasterLayout>
      <div class="fuelbalance_first_row" style="justify-content: center">
        <div class="fuelbalance_first_row_right_section asset_card">
          <div class="our__branches__banner">
            <div
              class="row align-items-center d-flex justify-content-center section__row"
            >
              <div class="col-md-6">
                <div class="pl-3">
                  <h5 class="primary-color">
                    {{ $t("text.cBank.hi") }}, {{ userName }}
                  </h5>
                  <div class="mt-3">
                    <span class="primary-color"
                      >{{ $t("text.bPos.youCan") }} :)</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6 text_right">
                <select
                  class="mr-3 banner-select-width"
                  v-model="posBank"
                  style=""
                >
                  <option value="select bank">
                    {{ $t("text.omit.allBanks") }}
                  </option>
                  <option
                    v-for="(bank, index) in banksList"
                    :value="bank"
                    :key="index"
                  >
                    {{ bank }}
                  </option>
                </select>
                <select class="banner-select-width" v-model="posCompany">
                  <option value="select company" style="width: 200px">
                    {{ $t("text.omit.allComp") }}
                  </option>
                  <option
                    v-for="(company, index) in companiesList"
                    :value="company"
                    :key="index"
                  >
                    {{ company }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="card_container" style="flex: 0 0 22%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button active_tab"
                style="height: 80px; width: 80px"
              >
                <h3 class="text-white">{{ terminalCount }}</h3>
              </div>
              <div class="text-center mt-3 bold-text primary-color">
                {{ $t("text.omit.allTerminals") }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div
            class="col-md-12 col-lg-12 mt-3"
            v-show="!showLoader && terminalCount > 0"
          >
            <ejs-grid
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :allowTextWrap="true"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="80" field="index" headerText="#"></e-column>
                <e-column
                  field="terminalId"
                  width="180"
                  headerText="Terminal Id"
                ></e-column>
                <e-column
                  width="200"
                  field="serialNo"
                  headerText="Serial No."
                ></e-column>
                <e-column
                  field="companyName"
                  width="180"
                  headerText="Company"
                ></e-column>
                <e-column
                  field="branchName"
                  width="180"
                  headerText="Branch"
                ></e-column>
                <e-column field="bank" width="180" headerText="Bank"></e-column>
                <e-column
                  field="slipHeader"
                  width="180"
                  headerText="Slip header"
                ></e-column>
                <e-column
                  field="slipFooter"
                  width="180"
                  headerText="Slip footer"
                ></e-column>

                <!-- <e-column :template="terminalTemplate" headerText="Action" width="350"></e-column> -->
              </e-columns>
            </ejs-grid>
          </div>
          <div class="col-md-12 col-lg-12 mt-3">
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <section
        class="products_summary__wrapper pb-5 mt-3"
        v-show="!terminalCount && !showLoader"
      >
        <div
          class="empty_tank_wrapper"
          style="
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 30px">
            <h6 style="color: rgb(161, 146, 146); font-size: 13px">
              There is currently no terminal created
            </h6>
          </div>

          <div class="text-center pb-5" style="margin-top: 50px">
            <img src="@/assets/img/gold-ingots.svg" width="170" />
          </div>
        </div>
      </section>
    </MasterLayout>
    <!-- <AssetDetails :modalData="asset"></AssetDetails> -->
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/posOwner/masterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import ReAssignPOSModal from "@/components/modals/POS/reAssignPOS.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import GetAsset from "@/components/modals/Assets/getAsset.vue";
import Paginator from "@/components/Paginator.vue";
import Temp from "@/components/terminalsTemplate.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "POS Terminals :: Epump Portal",
  name: "Assets",
  components: {
    MasterLayout,
    // AssetDetails,
    GetAsset,
    Paginator,
    TableLoader,
    ReAssignPOSModal,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      posBank: "select bank",
      posBanks: [],
      posOwners: [],
      posCompany: "select company",
      companiesList: [],
      asset: {},
      addAssetId: "",
      fromDate: null,
      toDate: null,
      branches: [],
      banksList: [],
      branchId: "allBranches",
      status: "allStatus",
      isActive: "selectActive",
      assetData: {},
      tableCount: 0,
      first: true,
      pageSize: "10",
      totalPages: 1,
      currentPage: 1,
      sortType: "",
      sortColumn: "",
      assetNumber: "",
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
      backgroundUrl,
      cardBackgroundUrl,
      groupAssets: [],
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      terminalCount: 0,
      modalData: {},
      terminalTemplate: function () {
        return {
          template: Temp,
        };
      },
    };
  },
  computed: {
    userName() {
      return `${this.userDetails.firstName} ${this.userDetails.lastName}`;
    },
  },
  created() {
    this.$eventHub.$on("_reAssignPOSModal", (data) => {
      this.modalData = data;
      this.$modal.show("reAssignPOS");
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("setAssetModalValue");
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getTerminals();
    this.getPosOwners();
  },
  watch: {
    posBank(val) {
      let tableData,
        index = 0;

      const terminalsArr = [...this.terminals];

      val == "select bank"
        ? (tableData = terminalsArr)
        : (tableData = terminalsArr.filter((exp) => exp.bank === val));

      if (val !== "select bank") {
        tableData.forEach((el) => {
          ++index;
          el.index = index;
        });
      }

      this.$refs.dataGrid.ej2Instances.setProperties({ dataSource: tableData });
      this.refreshGrid();
    },
    posCompany(val) {
      let tableData,
        index = 0;

      const terminalsArr = [...this.terminals];

      val == "select company"
        ? (tableData = terminalsArr)
        : (tableData = terminalsArr.filter((exp) => exp.companyName === val));

      if (val !== "select company") {
        tableData.forEach((el) => {
          ++index;
          el.index = index;
        });
      }

      this.$refs.dataGrid.ej2Instances.setProperties({ dataSource: tableData });
      this.refreshGrid();
    },
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getPosOwners() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/POS/GetOwners`,
          configObject.authConfig()
        )
        .then((res) => {
          this.posOwners = res.data;
        })
        .catch((error) => {});
    },
    getTerminals() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pos/Terminals`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.vendor.toLowerCase() > b.vendor.toLowerCase()
              ? 1
              : b.vendor.toLowerCase() > a.vendor.toLowerCase()
              ? -1
              : 0;
          });
          const banksList = [];
          const companies = [];
          res.data.forEach((el) => {
            banksList.push(el.bank);
            companies.push(el.companyName);
            el.index = ++index;
            el.transactionLimit = this.convertThousand(el.transactionLimit);
            el.fee = this.convertThousand(el.fee);
          });
          this.banksList = new Set(banksList);
          this.companiesList = new Set(companies);
          this.terminalCount = res.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style></style>
